import { EyeIcon } from "lucide-react";

// Unmistakable read-only indicator shown at the very top of a school portal when a KUVO staff
// member is previewing it. Sticky so it stays visible while scrolling (the portal nav below it is
// NOT sticky, so there is nothing to overlap). The server blocks every write regardless; this just
// keeps the read-only intent obvious throughout the page.
export function PreviewBanner() {
  return (
    <div className="sticky top-0 z-40 flex items-center justify-center gap-2 border-b border-amber-200 bg-amber-50 px-4 py-2 text-center text-sm text-amber-900 shadow-sm">
      <EyeIcon className="size-4 shrink-0" />
      <span>
        <span className="font-semibold">Alleen-lezen preview.</span> U bekijkt dit schoolportaal
        zoals de school het ziet. Wijzigingen worden niet opgeslagen.
      </span>
    </div>
  );
}
